import type { Distance } from "@pdfking/math"
import { NullQ } from "@pdfking/structs"

import type { Measure } from "#internal"

// `text` broken into lines no wider than `width` at `size`
export const WrapLines = ({
  measure,
  size,
  text,
  width,
}: {
  measure: Measure
  size: Distance
  text: string
  width: Distance
}): string[] =>
  text.split(" ").reduce<string[]>((lines, word) => {
    const last = lines[lines.length - 1]
    if (!NullQ(last) && measure(`${last} ${word}`, size) <= width)
      return [...lines.slice(0, -1), `${last} ${word}`]
    return [...lines, word]
  }, [])
